var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 131,
    viewBox: "0 0 150 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 150,
    height: 130,
    rx: 50,
    fill: "#8DAF61",
    fillOpacity: 0.54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2777_26209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.3672 33.0015L82.752 40.6304L99.8692 57.7476L107.484 50.1323C110.479 47.1382 110.479 42.2983 107.484 39.3042L101.195 33.0015C98.2012 30.0073 93.3614 30.0073 90.3672 33.0015ZM79.375 43.4331L78.1172 43.8159L58.4161 49.7222C55.6954 50.5425 53.5352 52.6206 52.6329 55.3276L40.5196 91.4487C40 92.9937 40.3829 94.7163 41.5176 95.8784L62.5176 74.8921C62.1075 74.0308 61.875 73.0737 61.875 72.062C61.875 68.439 64.8145 65.4995 68.4375 65.4995C72.0606 65.4995 75 68.439 75 72.062C75 75.6851 72.0606 78.6245 68.4375 78.6245C67.4258 78.6245 66.4688 78.3921 65.6075 77.9819L44.6075 98.9819C45.7832 100.117 47.4922 100.513 49.0371 99.98L85.1719 87.8667C87.8653 86.9644 89.9571 84.8042 90.7774 82.0835L96.6836 62.3823L97.0664 61.1245L79.375 43.4331Z",
    fill: "#436912"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2777_26209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(40 30.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellence);
export default __webpack_public_path__ + "static/media/Excellence.5ca3f6ded43cbe0958fd7901253f6467.svg";
export { ForwardRef as ReactComponent };